// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = ['M13 4L6 11L3 8'];
